import React from "react";
import { Box, Tooltip, Zoom } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.6);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(255, 77, 77, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 77, 77, 0);
  }
`;

const FloatingHomeReturn = () => {
  const handleGoHome = () => {
    // Full return to Zolang Home (safe for new tab usage)
    window.location.href = "/";
  };

  return (
    <Zoom in>
      <Tooltip title="Back to Zolang Home" placement="left" arrow>
        <Box
          onClick={handleGoHome}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 2000,
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: "linear-gradient(45deg, #8b0000, #ff4d4d)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            cursor: "pointer",
            animation: `${pulse} 2.5s infinite`,
            transition: "all 0.3s ease",
            boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
            "&:hover": {
              transform: "scale(1.12)",
              boxShadow: "0 12px 35px rgba(255,77,77,0.6)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ArrowBackIcon sx={{ fontSize: 20, mr: -0.5 }} />
            <HomeIcon sx={{ fontSize: 22 }} />
          </Box>
        </Box>
      </Tooltip>
    </Zoom>
  );
};

export default FloatingHomeReturn;
